import routes from 'constants/routes';
import { Route, Switch } from 'react-router-dom';

import PageNotFound from '../../components/pageNotFound';
import { CodeConfirmationContainer } from './components/CodeConfirmation';
import { ConfirmContainer } from './components/Confirm';
import { EmailContainer } from './components/Email';

export const UpdateEmail = () => {
  return (
    <Switch>
      <Route
        exact
        path={routes.me.updateEmail.start.path}
        component={CodeConfirmationContainer}
      />
      <Route
        exact
        path={routes.me.updateEmail.enterEmail.path}
        component={EmailContainer}
      />
      <Route
        exact
        path={routes.me.updateEmail.confirm.path}
        component={ConfirmContainer}
      />
      <Route component={PageNotFound} />
    </Switch>
  );
};
